import { addTrack, resetAudioList, setAutoPlay } from '../redux/slices/musicPlayerSlice';
import { setListContext } from '../redux/slices/listContextSlice';
import { resolveTrackSrc } from './resolvePlaybackSrc';
import { resolveCover } from './cover';
import { entityId } from './entityId';

// Start playback of a track list (Play All / play-from-index). Mirrors the
// feed's Play All: resolve only the STARTING track (full playback via
// resolveTrackSrc — YouTube → SoundCloud → snippet) and hand the whole list
// to the listContext so advanceListContext lazy-resolves the rest as the
// queue advances.
export const playAllTracks = async (dispatch, tracks, startIndex = 0) => {
    const items = (tracks || []).filter(Boolean);
    if (!items.length) return false;
    const idx = Math.min(Math.max(0, startIndex), items.length - 1);
    const first = items[idx];
    // Same feedback contract as row plays (DJPalAudioPreview): spin the
    // bottom player's button from the FIRST millisecond — resolving the
    // starting track can mean a lazy YouTube search + yt-dlp download, and
    // without this signal Play All felt dead until the audio landed.
    window.dispatchEvent(new CustomEvent('djpal-track-extract-start'));
    let resolved;
    try {
        // Hard cap the resolution: a hung resolve (track with no sample/link
        // and a stalled lazy-resolve IPC) would otherwise leave callers'
        // spinners stuck forever.
        resolved = await Promise.race([
            resolveTrackSrc(first),
            new Promise((r) => setTimeout(() => r(null), 25000)),
        ]);
    } finally {
        window.dispatchEvent(new CustomEvent('djpal-track-extract-end'));
    }
    if (!resolved) return false;
    dispatch(resetAudioList());
    dispatch(addTrack({
        name: first.title || 'Unknown Track',
        singer: first.artist || '',
        cover: resolveCover(first.artwork, first.artworkUrl, first.image),
        musicSrc: resolved.musicSrc,
        ...(resolved.isHls ? { isHls: true, hlsSrc: resolved.hlsSrc } : {}),
        ...(resolved.originalUrl ? { originalUrl: resolved.originalUrl } : {}),
        ...(first.pageUrl ? { pageUrl: first.pageUrl } : {}),
        trackId: entityId(first),
        ...(Array.isArray(first.artists) && first.artists.length ? { artists: first.artists } : {}),
    }));
    dispatch(setAutoPlay(true));
    dispatch(setListContext({ items, currentIndex: idx, type: 'tracks' }));
    return true;
};
